exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".call-back-app__question-button[data-v-3b815696]{width:75px;height:70px;background-position:50%;background-repeat:no-repeat;background-size:contain;background-image:url(\"/dist/img/clbquestcloud.webp\");cursor:pointer;position:absolute;bottom:20px;right:20px;z-index:1;filter:drop-shadow(0 0 2px #647484)}.call-back-app__question-button[data-v-3b815696]:after{content:\"\";width:70px;height:70px;background-position:50%;background-repeat:no-repeat;background-size:auto;background-image:url(\"/dist/img/clbquestcloud2.webp\");position:absolute;top:-2px;left:3px}.fade-enter-active[data-v-3b815696],.fade-leave-active[data-v-3b815696]{transition:opacity .5s}.fade-enter[data-v-3b815696],.fade-leave-to[data-v-3b815696]{opacity:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3b815696","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./app/Sites/AT/assets/js/vue/components/callback/QuestionButton.vue
// module id = 132
// module chunks = 0 1